import { render } from "./ApiCredential.vue?vue&type=template&id=0df6b8d6"
import script from "./ApiCredential.vue?vue&type=script&lang=js"
export * from "./ApiCredential.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__